/**
 * Paleta unificada para gráficos del dashboard.
 * Cyan-teal-esmeralda + lila (botón Venta) + amarillo.
 */

export const chartPalette = {
  /** Acentos principales */
  accent: {
    cyan: '#06b6d4',
    teal: '#14b8a6',
    emerald: '#10b981',
    tealDark: '#0d9488',
    tealLight: '#2dd4bf',
    sky: '#0ea5e9',
    /** Lila del botón Venta (lavanda → violeta) */
    violet: '#7c3aed',
    violetLight: '#a78bfa',
    lavender: '#c4b5fd',
    /** Amarillo */
    yellow: '#eab308',
    yellowLight: '#facc15',
  },

  /** Colores para series/barras múltiples - incluye lila y amarillo */
  series: [
    '#06b6d4', // cyan
    '#14b8a6', // teal
    '#7c3aed', // lila (botón Venta)
    '#eab308', // amarillo
    '#0d9488', // teal oscuro
  ],

  /** Gradientes para áreas/líneas */
  gradients: {
    sales: ['#06b6d4', '#14b8a6'],
    units: ['#14b8a6', '#06b6d4'],
    /** Gradiente lila como el botón Venta */
    violet: ['#c4b5fd', '#7c3aed'],
    default: ['#06b6d4', '#14b8a6'],
  },

  /** Estados semánticos */
  status: {
    success: '#14b8a6',
    inProgress: '#06b6d4',
    warning: '#f59e0b',
    neutral: '#64748b',
    error: '#f87171',
  },

  /** Texto y fondos sobre dark */
  onDark: {
    text: '#ffffff',
    textMuted: 'rgba(255, 255, 255, 0.7)',
    border: 'rgba(255, 255, 255, 0.08)',
    grid: 'rgba(255, 255, 255, 0.05)',
  },
} as const;
